export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.tagSelect.day': 'Day',
  'component.tagSelect.mouth': 'Mouth',
  'component.tagSelect.year': 'Year',
  'component.tagSelect.disable': 'Disable',
  'component.tagSelect.enable': 'Enable',
  'component.tagSelect.normal': 'Normal',
  'component.tagSelect.man': 'Man',
  'component.tagSelect.woman': 'Woman',
  'component.tagSelect.yes': 'Yes',
  'component.tagSelect.no': 'No',

  'component.button.more': 'More',
  'component.button.search': 'Search',
  'component.button.reset': 'Reset',
  'component.button.add': 'Add',
  'component.button.addDevice': 'Add Equipment',
  'component.button.ConfirmPasswordReset': 'Confirm password reset?',
  'component.button.PasswordResettigs':
    'Please remember the password, it will only be displayed once!',
  'component.button.copydone': 'Copied to the clipboard',
  'component.button.copypas': 'Copy password',
  'component.button.PasswordResetmsg': 'Password reset successful!',
  'component.button.ResetPassword': 'Reset password',
  'component.button.roleAssignment': 'Role assignment',
  'component.button.AssignedRole': 'Assigned role',
  'component.button.undistributed': 'Undistributed role',
  'component.button.edit': 'Edit',
  'component.button.sure': 'Sure',
  'component.button.Cancel': 'Cancel',
  'component.button.goback': 'Goback',
  'component.button.AssignPermissions': 'Assign permissions',
  'component.button.save': 'Save',
  'component.button.detail': 'Detail',
  'component.button.delete': 'Delete',
  'component.button.uploadPic': 'Upload pic',
  'component.button.uploadfile': 'Upload file',
  'component.button.uploadfile1': 'Upload file(supports multiple)',
  'component.button.files': 'Supplementary files(supports multiple)',
  'component.button.delay': 'Extend',
  'component.button.binding': 'Binding',
  'component.button.account': 'Account',
  'component.button.password': 'Password',
  'component.button.upload': 'Upload',
  'component.button.download': 'Download',
  'component.button.Reupload': 'Re upload',

  'component.Placeholder.select': 'Please select',
  'component.Placeholder.input': 'Please input',
  'component.Placeholder.inputuser': 'Please input username',
  'component.Placeholder.rulesPhone': 'Please enter the correct phone number!',
  'component.Placeholder.rulesemail': 'Please enter the correct email address!',
  'component.Placeholder.gneder': 'Please select gender',
  'component.Placeholder.inputrole': 'Please input role',
  'component.Placeholder.inputRequired': 'Please input content!',

  'component.title.EnableUser': 'Enable user?',
  'component.title.disabledUser': 'Disabled user?',
  'component.title.suredeleterole': 'Delete role?',
  'component.title.suredeleteship': 'Do you want to delete the ship?',
  'component.title.suredeletepad': 'Do you want to delete the pad?',
  'component.title.editUser': 'Edit user',
  'component.title.Selected': 'Selected',
  'component.title.items': 'Items',
  'component.title.addRole': 'Add role',
  'component.title.createRole': 'Create role',
  'component.title.enable': 'Do you want to enable it?',
  'component.title.disabled': 'Do you want to disable it?',
  'component.title.binddevicesuccess': 'Device binding successful!',
  'component.title.binddevice': 'Binding device',

  'component.title.EnergyList': 'Energy list',
  'component.title.Energytigs':
    'Choose the commonly used fuel types for this ship, up to a maximum of 5',
  'component.title.Energytigs1': 'Up to 5 types of fuel',

  'component.title.CorrectedCIIrating': 'Corrected CII rating',
  'component.title.CorrectedCIIrating1': 'Select the vessel to which it belongs',
  'component.title.CorrectedCIIrating2': "Last year's rating",
  'component.title.CorrectedCIIrating3': 'Details of CII ratings for the selected vessel over the past year',
  'component.title.CorrectedCIIrating4': 'Set rating targets',
  'component.title.ciiRating': 'CII rating objectives',

  'shipWeb.workplace.SummaryAnalysis': 'Summary analysis',
  'shipWeb.workplace.customers': 'Total number of customers',
  'shipWeb.workplace.treasures': 'The number of carbon treasures',
  'shipWeb.workplace.sailingRecord': 'Annual sailing record (s)',
  'shipWeb.workplace.emissions': 'Total annual carbon emissions (tons)',
  'shipWeb.workplace.travelled': 'Annual miles travelled (nautical miles)',
  'shipWeb.workplace.addCustomer': 'New customer',
  'shipWeb.workplace.updateCustomer': 'Update Customer',
  'shipWeb.workplace.ImminentCustomer': 'Imminent customer',
  'shipWeb.workplace.LatestVoyageRecords': 'Latest voyage records',
  'shipWeb.workplace.EnergyConsumptionAndCarbonEmissions':
    'Energy consumption and carbon emissions',

  'system.usermanage.usermanage': 'Users management',
  'system.rolesmanage.rolesmanage': 'Roles management',
  'system.customer.customer': 'Customer list',
  'system.ship.shiplist': 'Ship list',
  'system.addship.Basicdata': 'Basic data',
  'system.addship.TypesofEnergy': 'Types of energy',
  'system.addship.nextStep': 'Next step',
  'system.addship.PreviousStep': 'Previous step',
  'system.pad.padlist': 'List of Van carbon treasures',
  'system.pad.addpad': 'Add Van carbon treasures',
  'system.pad.editpad': 'Edit Van carbon treasures',
  'all.table.Cargocapacity': 'Cargo capacity',

  'component.footer.copyright': 'Powered by Ant Design',
  'component.footer.antDesignPro': 'Ant Design Pro',
  'component.footer.antDesign': 'Ant Design',
  'component.avatarDropdown.personalCenter': 'Personal Center',
  'component.avatarDropdown.personalSettings': 'Personal Settings',
  'component.avatarDropdown.logout': 'Logout',
};
